/**
 * Footer Module - Configuration
 *
 * Centralized configuration for footer sections.
 * All hardcoded data is stored here for easy maintenance.
 */

import type { FooterSection, CompanyInfo } from '../types'

// =============================================================================
// FOOTER SECTIONS CONFIG
// =============================================================================

/**
 * Customer support section
 */
export const customerSupportSection: FooterSection = {
  title: 'Suport clienti',
  links: [
    { title: 'Cum cumpar', href: '/cum-cumpar.html' },
    { title: 'Transport si livrare', href: '/transport-si-livrarea-produselor.html' },
    { title: 'Retur produse', href: '/avantaje-cumparaturi-online/#returnare' },
    { title: 'Service produse', href: '/retea-service.html' },
  ],
}

/**
 * General information section
 */
export const generalInfoSection: FooterSection = {
  title: 'Informatii generale',
  links: [
    { title: 'Certificari ISO', href: '/certificari-iso.html' },
    { title: 'Garantie si conformitate', href: '/garantie-conformitate.html' },
    { title: 'Protectia datelor personale', href: '/protectia-datelor-personale' },
    { title: 'Termeni si conditii', href: '/termeni-si-conditii' },
    {
      title: 'Solutionarea online a litigiilor (SAL)',
      href: 'https://reclamatiisal.anpc.ro',
      external: true,
    },
    { title: 'Info ANPC', href: 'https://anpc.ro/', external: true },
  ],
}

/**
 * Useful links section
 */
export const usefulLinksSection: FooterSection = {
  title: 'Linkuri utile',
  links: [
    { title: 'Autentificare', href: '/customer/account/login' },
    { title: 'Comenzile mele', href: '/sales/order/history' },
    { title: 'Wishlist', href: '/wishlist' },
    { title: 'Promotii', href: '/promotii-scule-echipamente.html' },
    { title: 'Lichidare stoc', href: '/lichidare-stoc.html' },
    { title: 'Producatori', href: '/producator.html' },
  ],
}

/**
 * About us section
 */
export const aboutUsSection: FooterSection = {
  title: 'Tools.Store.ro',
  links: [
    { title: 'Despre noi', href: '/despre-noi' },
    { title: 'Magazine', href: '/magazine' },
    { title: 'Blog', href: 'https://blog.tools.store.ro/', external: true },
  ],
}

// =============================================================================
// COMPANY INFO CONFIG
// =============================================================================

/**
 * Company contact information
 */
export const companyInfo: CompanyInfo = {
  name: 'Global Tech SRL',
  address: 'Soseaua Pacurari 86A',
  phone: '0377 100 000',
  email: 'online.sales@tools.store.ro',
}

// =============================================================================
// FOOTER CONFIG OBJECT
// =============================================================================

/**
 * Complete footer configuration
 */
export const footerConfig = {
  customerSupport: customerSupportSection,
  generalInfo: generalInfoSection,
  usefulLinks: usefulLinksSection,
  aboutUs: aboutUsSection,
  companyInfo: companyInfo,
} as const

export type FooterConfig = typeof footerConfig
